import { FC } from 'react';
import { PromoFeatures } from 'shared/components/PromoFeatures';
import { UniqueViewContainer } from 'shared/containers/UniqueView';
import { NewPromoContainer } from 'shared/containers/NewPromo';
import { LimitPromoContainer } from 'shared/containers/LimitPromo';
import { BypassAlternatives } from 'shared/components/BypassAlternatives';
import { MoreViewsBanner } from 'shared/components/MoreViewsBanner';
import { PayRealResult } from 'shared/components/PayRealResult';
import { AdRanking } from 'shared/components/AdRanking';
import { AutoStrategiesBanner } from 'shared/components/AutoStrategiesBanner';
import { ChangeTechRecXML } from 'shared/components/ChangeTechRecXML';
import { FaqContainer } from '../Faq';

export const MainContentContainer: FC = () => {
  return (
    <>
      <NewPromoContainer title="Новое продвижение на Циан" subtitle="С оплатой только за результат" />
      <PromoFeatures />
      <UniqueViewContainer />
      <LimitPromoContainer />
      <BypassAlternatives />
      <MoreViewsBanner />
      <PayRealResult />
      <AdRanking />
      <AutoStrategiesBanner />
      <ChangeTechRecXML />
      <FaqContainer />
    </>
  );
};
